import { useEffect } from "react";
import { ensureFreshSession } from "../helper/helper";
import { expireSession } from "../services/interceptor";

/**
 * Keeps the signed-in session honest: renews the access token before it expires (on load, when the tab
 * regains focus, and every minute), and when the session is definitively dead tells the user and sends
 * them to sign in again, instead of leaving a stale cookie that still looks like a signed-in user.
 */
const useSessionKeepAlive = () => {
  useEffect(() => {
    const check = () => {
      if (document.visibilityState === "hidden") return;
      void ensureFreshSession();
    };
    check();
    const id = window.setInterval(check, 60_000);
    document.addEventListener("visibilitychange", check);
    window.addEventListener("focus", check);
    window.addEventListener("auth-session-expired", expireSession);
    return () => {
      window.clearInterval(id);
      document.removeEventListener("visibilitychange", check);
      window.removeEventListener("focus", check);
      window.removeEventListener("auth-session-expired", expireSession);
    };
  }, []);
};

export default useSessionKeepAlive;
